import { useRef, useEffect } from 'react';

// Grows a textarea to fit its content as `value` changes, up to whatever max-height
// the caller sets via CSS (overflow-y: auto then takes over with a scrollbar).
export function useAutoGrowTextarea(value) {
  const ref = useRef(null);

  useEffect(() => {
    const ta = ref.current;
    if (!ta) return;
    const { borderTopWidth, borderBottomWidth } = getComputedStyle(ta);
    const borderHeight = parseFloat(borderTopWidth) + parseFloat(borderBottomWidth);
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + borderHeight + 'px';
  }, [value]);

  return ref;
}
